import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { fetchProducts } from "../../../store/product.slice";
import { Link, useNavigate } from "react-router-dom";

const ProductSearchBar = () => {
  const navigate = useNavigate();
  const [filteredProducts, setFilteredProducts] = useState([]);
  // const [products, setProducts] = useState([]);
  const dispatch = useDispatch();
  
  useEffect(() => {
    dispatch(fetchProducts());
  }, [dispatch]);

  const products = useSelector((state) => state.products.products);

  const handleChange = (e) => {
    console.log(e.target.value);
    const searchQuery = e.target.value;

    let tempProducts = [...products];

    if (searchQuery !== "" ) {
      tempProducts = tempProducts.filter(
        (product) =>
          product.name.toLowerCase().includes(searchQuery.toLowerCase()) ||
          product.category.name
            .toLowerCase()
            .includes(searchQuery.toLowerCase())
        //   ||
        // product.vendor.toLowerCase().includes(searchQuery.toLowerCase())
      );
    } else if(searchQuery.length === 0 || searchQuery === "") {
      tempProducts = [];
      // Clear filteredProducts when input is empty
      setFilteredProducts(tempProducts);
    }

    setFilteredProducts(tempProducts);
  };

  const goToroductDetail = (productId) => {
    navigate(`/market-place/product-details/${encodeURIComponent(btoa(productId))}`);
  };

  return (
    // <div

    // >
    // <div className="offcanvas-body">
    // <div className="container">
    // <div className="w-lg-75 mx-lg-auto">
    <div
      className="offcanvas offcanvas-top offcanvas-navbar-search bg-light pb-10 pt-5 "
      tabIndex="-1"
      aria-modal="true"
      role="dialog"
      id="offcanvasNavbarSearch"
      aria-labelledby="offcanvasNavbarSearchLabel"
    >
      <div className=" position-relative w-lg-50 mx-lg-auto ">
        <div className=" d-flex justify-content-end mb-3">
          <button
            type="button"
            className="btn-close text-reset"
            data-bs-dismiss="offcanvas"
            aria-label="Close"
          ></button>
        </div>
        <div className="mb-">
          <form>
            <div className="input-card">
              <div className="input-card-form">
                <input
                  type="text"
                  className="form-control form-control-lg"
                  placeholder="Search Product"
                  aria-label="Search Product"
                  name="search"
                  id="search"
                  onChange={handleChange}
                />
              </div>
              <button type="button" className="btn btn-primary btn-lg">
                Search
              </button>
            </div>
          </form>
        </div>

        {/* Conditionally render the results section */}
        {filteredProducts.length > 0 && (
          <div
            className={` bg-white rounded-1 shadow mt-2 p-2 px-4 w-lg-100 mx-lg-auto position-absolute   `}
          >
            {filteredProducts.map((product) => {
              return (
                <>
                  <div
                    key={product.id}
                    data-bs-dismiss="offcanvas"
                    aria-label="Close"
                    onClick={() => goToroductDetail(product.id)}
                    style={{ cursor: "pointer" }}
                    className=" d-flex align-items-center justify-content-between mb-2"
                  >
                    <div className=" d-flex justify-content-center align-items-center">
                      {/* <span> <img src={product.image} height={50} width={50} alt="searchProduct" /></span> */}
                      <span className=" mx-2 ">{product.name}</span>
                    </div>

                    <span>{product.category.name}</span>
                  </div>
                  {/* <hr /> */}
                </>
              );
            })}
          </div>
        )}
      </div>
    </div>
    // </div>
    // </div>
    // </div>
    // </div>
  );
};

export default ProductSearchBar;
